module.exports = __webpack_public_path__ + "img/47.864bb7d2.png";